import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withSizes from 'react-sizes'

import choicesPropTypes from "../../propTypes/choices";
import vehicleDetailPropTypes from "../../propTypes/vehicleDetail";

import TagManager from '../../TagManager';
import {t} from '../../Translations';
import {mapSizesToProps} from "../../utils";
import StepTitle from "../widgets/StepTitle";
import Step1Choices from "../widgets/Step1Choices"
import Annotation from "../widgets/Annotation";
import Button from "../widgets/Button";
import AverageConsumptionResult from "./AverageConsumptionResult";
import VehicleDetail from "../widgets/VehicleDetail";
import Configuration from "../../Configuration";

class Step1 extends React.Component {
    static propTypes = {
        className: PropTypes.string,

        // Data chosen by the user
        data: PropTypes.object.isRequired,

        // The user chosen vehicle detail, in human reading format
        vehicleDetail: vehicleDetailPropTypes,

        choices: choicesPropTypes.isRequired,

        // Whether rims data are loading or not
        loadingRims: PropTypes.bool,

        // Whether the consumption is calculating or not
        calculatingConsumption: PropTypes.bool,

        // The average consumption data
        averageConsumptionData: PropTypes.object,

        // Contains data regarding the consumption
        consumptionData: PropTypes.object,

        // Whether the next button is enabled or disabled
        enableNextButton: PropTypes.bool,

        // Whether the calculate button is enabled or disabled (only for mobile)
        enableCalculateButton: PropTypes.bool,

        // Whether the component is displayed on mobile or not
        isMobile: PropTypes.bool.isRequired,

        // Call parent onNextStep()
        onNextStep: PropTypes.func.isRequired,

        // Call parent onDataChange(key, value)
        onDataChange: PropTypes.func.isRequired,

        // Call parent onCalculateAverageConsumption()
        onCalculateAverageConsumption: PropTypes.func.isRequired,
        
        // Call parent onVehicleChange()
        onVehicleChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        vehicleDetail: {},
        calculateConsumption: false,
        loadingRims: false,
        averageConsumptionData: undefined,
        enableNextButton: false,
        enableCalculateButton: false,
        isMobile: false,
        imageSrc:undefined,
    }

    componentDidMount() {
        TagManager.sendEvent(
            '/consommation/form/estimation-moyenne-vehicule/step-1',
            'form page',
            null,
            'consommation estimation moyenne',
            1,
            'consommation'
        )
    }

    /**
     * Calling parent onDataChange with key and value set
     * 
     * @param {string}  key
     * @param {*}       value
     */
    onDataChange = key => value => {
        this.props.onDataChange && this.props.onDataChange(key, value);
    }



    render() {
        const {
            className, 
            data, 
            vehicleDetail,
            averageConsumptionData, 
            calculatingConsumption,
            choices,
            loadingRims,
            isMobile, 
            enableNextButton,
            enableCalculateButton,
            onNextStep, 
            onCalculateAverageConsumption,
            onVehicleChange
        } = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? "ap":"");
        const classes = classNames(
            "cccu-step-average-consumption",
            "row",
            "justify-content-center",
            {
                [className]: className !== undefined
            }
        );

        return (
            <div className={classes}>
                <div className="col-12 col-md-10" >
                    {(!isMobile || !averageConsumptionData) &&
                    <div style={{marginTop:29}}>
                         <StepTitle >{t('Step1_title')}<sup>(1)</sup></StepTitle>  
                    </div>

                      
                    }

                    <div className="row">
                        {(!isMobile || (!averageConsumptionData && !calculatingConsumption)) &&
                            <React.Fragment>
                                <div className="col-12">
                                    <small className={client}>{t('Step1_mandatory')}</small>
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-7 col-lg-6 form-vehicule">
                                    <Step1Choices 
                                        data={data} 
                                        choices={choices} 
                                        loadingRims={loadingRims} 
                                        onDataChange={this.onDataChange} 
                                    />
                                </div>
                            </React.Fragment>
                        }

                        {(!isMobile || (calculatingConsumption || averageConsumptionData)) &&
                            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-6">
                                {isMobile &&
                                    <VehicleDetail
                                        model={vehicleDetail.model}
                                        bodyStyle={vehicleDetail.bodyStyle}
                                        commercialName={vehicleDetail.commercialName}
                                        engine={vehicleDetail.engine}
                                        transmission={vehicleDetail.transmission}
                                        rims={vehicleDetail.rims}
                                        onVehicleChange={onVehicleChange} 
                                    />
                                }

                                <AverageConsumptionResult
                                    consumption={averageConsumptionData ? averageConsumptionData.consumption : undefined}
                                    pn={averageConsumptionData ? averageConsumptionData.pn : undefined}
                                    nox={averageConsumptionData ? averageConsumptionData.nox : undefined}
                                    calculating={calculatingConsumption}
                                    enableNextButton={enableNextButton}
                                    onValidate={onNextStep}
                                />
                            </div>
                        }

                        {isMobile && !averageConsumptionData && !calculatingConsumption &&
                            <div className="col-xs-12 col-sm-12 col-md-7 col-lg-6">
                                <Button disabled={!enableCalculateButton} onClick={onCalculateAverageConsumption}>
                                    {t('CTA_Calculate')}
                                </Button>
                            </div>
                        }
                    </div>
                </div>
                <div className="annotation-container annotation-step1 col-12 col-md-10">

                     <Annotation>{t("Step1_legal_conso")}</Annotation>

                     <Annotation>{t("Step1_Result_legal_refine")}</Annotation>
        
                     {(!averageConsumptionData || (averageConsumptionData && averageConsumptionData.nox)) ? (  

                    <Annotation>{t("Step1_legal_emissions")}</Annotation>
                        ):(
                        <Annotation></Annotation>)}

                   </div>

            </div>
        )
    }
}

export default withSizes(mapSizesToProps)(Step1);



// WEBPACK FOOTER //
// ./src/components/steps/Step1.js